import { useState } from 'react';
// import { Container } from 'reactstrap';
import gridImage from '../../assets/images/icon_home_girdview.png';
import tilesImage from '../../assets/images/Tilesview.png';
import { useSelector, useDispatch } from 'react-redux';
import { setView, hideLoader } from '../redux/ctrl/ctrlActions';
import { setProjInitAct } from '../redux/project/projActions';
import RefreshIcon from '../refreshIcon/RefreshIcon';
import GridRefresh from '../gridRefresh/GridRefresh';
import { Container } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Chip from '@mui/material/Chip';
import { LuFilterX } from 'react-icons/lu';
import StyledTooltip from '../shared/toolTip/StyledTooltip';

const UserProjects = (props) => {
  const dispatch = useDispatch();
  const quoteSearchResults = useSelector((state) => state.project.quoteSearchResults);
  const ctrlState = useSelector((state) => state.ctrl)
  const getPhase = useSelector((state) => state.project.phase);
  const projectState = useSelector((state) => state.project);
  const profileState = useSelector((state) => state.profile);
  const gridRefresh = false;
  const [ctrl, setCtrl] = useState(ctrlState);
  const newTheme = { ...ctrlState };
  const { t, i18n } = useTranslation();
  const dataDisplayStyle = () => {
    if (newTheme.hideGrid === true && newTheme.hideTiles === false) {
      newTheme.hideGrid = false;
      newTheme.hideTiles = true;
      newTheme.labeltoDisplay = t('Table View');
    }
    else {
      newTheme.hideGrid = true;
      newTheme.hideTiles = false;
      newTheme.labeltoDisplay = t('Tiles View');
    }
    setCtrl(newTheme)
    dispatch(setView(newTheme));
  }

  if (getPhase === "SUCCESS") {
    setTimeout(() => { dispatch(setProjInitAct('INIT')) }, 1000);
    setTimeout(() => { dispatch(hideLoader(false)); }, 1000);

  }

  const getLabel = () => {
    const { quote_number, package_name } = props.advanceSearchFields;
    let label = '';

    if (package_name && quote_number) {
      label = `MyProject Workspace Quote Number: ${quote_number}, Package Name: ${package_name}`;
    } else if (package_name) {
      label = `Package Name: ${package_name}`;
    } else if (quote_number) {
      label = `MyProject Workspace Quote Number: ${quote_number}`;
    }

    return label;
  }

  const deleteChip = () => {
    props.clearSearch();
  }

  return (
    <>
      <Container maxWidth="xl" className="container-flud" style={{ paddingRight: '16px' }}>
        <div className='d-flex pt-2 '>
          <h5 className='cmnlblfnt1'> {t('Recent Projects')}</h5>
          {/*filter  */}
          {quoteSearchResults?.package?.length > 0 ?
            <Chip
              className="chip-custom project-chip"
              label={getLabel()}
              onDelete={deleteChip}
            /> : null}
          {gridRefresh &&
            <GridRefresh pageName='Projects' onClickRefresh={props.onClickRefresh} key={1} gridDataCnt={projectState.projectsCnt} dataCnt={profileState.appAcc[0].project_count} />}
          <div style={{ display: 'flex', justifyContent: 'right', flex: '1', flexDirection: 'row-reverse', alignItems: 'center', gap: '8px' }}>
            {/* clear filter */}
            <div onClick={() => dataDisplayStyle()} style={{ cursor: 'pointer', border: '1px solid #4ba781' }}>
              <img /*className="d-inline-block align-top"*/ src={gridImage} className="mx-1 my-1" height="23" alt="gridImage" hidden={ctrlState.labeltoDisplay === 'Table View' ? false : true}></img>
              <img /*className="d-inline-block align-top"*/ src={tilesImage} className="mx-1 my-1" height="23" alt="tilesImage" hidden={ctrlState.labeltoDisplay === 'Table View' ? true : false}></img>
              <span className='mr-2 my-2' style={{ color: '#4ba781' }} >{ctrlState.labeltoDisplay}    &nbsp;</span>
            </div>
            {ctrlState.hideGrid && <StyledTooltip title={t('Clear Filters')} placement="bottom" disableInteractive>
              <div
                onClick={() => window.dispatchEvent(new Event('pgrid-clear-filters'))}
                style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', padding: '2px 4px' }}
              >
                <LuFilterX style={{ color: '#4ba781', fontSize: '18px' }} />
              </div>
            </StyledTooltip>}
          </div>
        </div>
      </Container>
    </>
  )
}

export default UserProjects;